module.exports = "\r\n<br />\r\n<br />\r\n<br />\r\n<div align='center'>\r\n  <b>You have selected to exit the System.</b><br/>\r\n    System session ended...\r\n  <br />\r\n  <br />\r\n  <br/>\r\n  <br />\r\n    <strong>Click <a routerLink='/' routerLinkActive='active' href >here</a> to sign on again.</strong>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/exit/exit.component.html
// module id = ./src/app/exit/exit.component.html
// module chunks = app